export const gpacTokens = {
    SUBTITLES_COMMAND_TOKEN: "{subtitlesCommand}",
    SUBTITLES_FILE_PATH_TOKEN: "{subtitleFilePath}",
    SOUNDTRACKS_FILE_PATH_TOKEN: "{soundtrackFilePath}",
    SOUNDTRACKS_COMMAND_TOKEN: "{soundtracksCommand}",
    LANGUAGE_ISO639_TOKEN: "{language.iso639}",
    LANGUAGE_LARG_TOKEN: "{language.laRg}",
    LANGUAGE_SPECIFICATION_TOKEN: "{languageSpec}",
    VIDEO_FILE_PATH: "{videoFilePath}"
};
